import {h, Component} from "preact";
import style from './style.scss';
import SectionComponent from "../../../layout/section-component";
import ToolbarButton from "../../../common/toolbar-button";
import AppListItem from "../app-list-item";
import DropDownMenu from "../../../common/dropdown";
import {OutsideClickWrapper} from "../../../layout/outside-click-wrapper";
import ModuleLogoLinkProvider from "../../../../services/ModuleLogoLinkProvider";
import VerticalUiContainer from "../../../layout/vertical-ui-container";
import ScrollableSection from "../../../layout/scrollable-section";
import {translate, TranslateService} from "../../../../services/TranslateService";
import AppsIcon from "mdi-preact/AppsIcon";
import ConfigService from "../../../../services/ConfigService";
import Toolbar from "../../../layout/toolbar";
import ToolbarTitle from "../../../layout/toolbar-title";
import Text from "../../../common/text";
import ModuleInfoProvider from "../../../../services/ModuleInfoProvider";

export default class OrganigrammaAppList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            logoError: false
        };
    }

    static defaultProps = {
        currentApp: {},
        apps: []
    };

    render(props, state, context) {
        const apps = this.getSortedAreaApps(this.props.apps);
        const currentAppName = TranslateService.translatable(props.currentApp.denomination);
        const buttonStyles = this.state.open ? {background: '#0079B8'} : {};

        const logo = () => {
            return (this.state.logoError) ?
                (<span>{currentAppName}</span>) :
                (
                    <img class={style.buttonImage}
                         src={ModuleLogoLinkProvider.transform(this.props.currentApp.key, 'svg', [], 'module-logo-reverse')}
                         alt={currentAppName}
                         onError={this.onLogoError}
                    />
                );
        };

        return (
            <SectionComponent>
                <OutsideClickWrapper watch={this.state.open} onOutsideClick={this.toggleMenu}>
                    <div style={{height: '100%'}}>
                        <ToolbarButton onClick={this.toggleMenu} title={translate('app.list.title')} style={buttonStyles}>
                            <AppsIcon/>
                        </ToolbarButton>
                        <DropDownMenu open={this.state.open} class={style.dropdownMenu} closeFunction={this.toggleMenu}>
                            <VerticalUiContainer>
                                <Toolbar class={style.toolbar}>
                                    <div class={style.iconButton}><AppsIcon/></div>
                                    <ToolbarTitle><Text text={'app.list.title'}/></ToolbarTitle>
                                </Toolbar>
                                <ScrollableSection style={{paddingBottom: '.5em'}}>
                                    {apps.map(a => <AppListItem app={a}/>)}
                                </ScrollableSection>
                            </VerticalUiContainer>
                        </DropDownMenu>
                    </div>
                </OutsideClickWrapper>
                <ToolbarButton onClick={this.navigateToHomePage} class={style.logoButton}>
                    {logo()}
                </ToolbarButton>
            </SectionComponent>
        );
    }

    onLogoError = () => {
        this.setState({
            logoError : true
        })
    };

    toggleMenu = () => {
        this.setState({open: !this.state.open})
    };

    navigateToHomePage = () => {
        ConfigService.navigateFunction(ConfigService.homepageUrl());
    };

    getSortedAreaApps(apps) {
        const filteredApps = apps.filter(app => app.tags.includes('area') && app.urls.hasOwnProperty('backend') && ModuleInfoProvider.isEnabled(app.key));
        return filteredApps.sort((a, b) => {
            if (a.position < b.position) return -1;
            if (a.position > b.position) return 1;
            else return 0;
        });
    }
}



// WEBPACK FOOTER //
// ./components/sections/apps/app-list/index.js